import React from "react";
import Header from "./header";
import Footer from "./footer";
import { GlobalStyle } from "../styles/global";
import SEO from "./seo";
import { HelmetProvider } from "react-helmet-async";

const Layout = ({ children, title, description, keywords, image, article }) => {
  return (
    <HelmetProvider>
      <SEO
        title={title}
        description={description}
        keywords={keywords}
        image={image}
        article={article}
      />
      <GlobalStyle />
      <div id="scroll-container">
        <Header />
        <main>{children}</main>
        <Footer />
      </div>
    </HelmetProvider>
  );
};

export default Layout;
